import React from 'react'
import Header from '../common/header/Header'
import TotalCount from './total-count'

const Dashboard = () => {
    return (
        <div>
            <Header headertitle="Dashboard" />
            <TotalCount />
        </div>
    )
}

export default Dashboard